import { Request } from '@mam/main/ApiClient';

export enum NotificationEmailHtmlBodyError {}

export class NotificationEmailHtmlBodyRequest implements Request<string, string> {
	public readonly api = 'pigeon';
	public readonly knownErrorCodes = Object.values(NotificationEmailHtmlBodyError);
	public readonly path: string;

	public constructor(notificationId: string, emailNotificationId: string) {
		this.path = `notifications/${notificationId}/emails/${emailNotificationId}/body/html`;
	}
}
